module.exports = __webpack_public_path__ + "img/empty_img.b281b6ad.png";